import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import useFetchOptions from "../hooks/use-fetch-options.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const {reasonOptions, cityFactOptions} = useFetchOptions();

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label="Natureza *"
                        isMulti={true}
                        wrapValues={true}
                        options={reasonOptions}
                        value={filters.reason}
                        onChange={(value) => setFilters(prev => ({...prev, reason: value}))}
                        instanceId="reason"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label="Município do fato"
                        isMulti={true}
                        wrapValue={true}
                        options={cityFactOptions}
                        value={filters.cityFact}
                        onChange={(value) => setFilters(prev => ({ ...prev, cityFact: value }))}
                        instanceId="cityFact"
                        classNameWrapper={"w-full"}
                    />

                    <InputCheckbox
                        id="archivedOccurrences"
                        label="Contabilizar ocorrências arquivadas"
                        className={'mb-2 ml-1'}
                        checked={filters.archivedOccurrences}
                        onChange={(e) => setFilters(prev => ({...prev, archivedOccurrences: e.target.checked}))}
                    />

                    <InputCheckbox
                        id="onlyMyCity"
                        label="Apenas ocorrências da minha corporação"
                        className={'ml-1'}
                        checked={filters.onlyMyCity}
                        onChange={(e) => setFilters(prev => ({...prev, onlyMyCity: e.target.checked}))}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;